// @vendors
import { Tabs } from 'antd'
// @styles
import './styles.scss'

const { TabPane } = Tabs

export default function Benefits({ data }) {

    return (
        <div className="benefits__container">
            <div className='container-xl'>
                <div className='benefits__container-content'>
                    <div className='benefits__container-content-text'>
                        <div className='benefits__container-content-text-title'>
                            Más antigüedad, más beneficios
                        </div>
                        <div className='benefits__container-content-text-description'>
                            A medida que sumas permanencia con nosotros, accedes a estas coberturas adicionales: Por ejemplo
                        </div>
                        <Tabs
                            defaultActiveKey="1"
                            className='tabs-timeline'
                            centered
                        >
                            {data && data.length > 0 ?
                                data.map((benefit) => (
                                    <TabPane tab={benefit.tabTitle} key={benefit.tabTitle}>
                                        {benefit.items.map((item, index) => (
                                            <div className='benefit-item' key={index}>
                                                <div className='benefit-item-image'>
                                                    <img src={item.image.url} alt={item?.image?.alt}/>
                                                </div>
                                                <div className='benefit-item-title'>
                                                    {item.message}
                                                </div>
                                            </div>
                                        ))}
                                    </TabPane>
                                ))
                                : null
                            }
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>
    )
}